<p-table [value]="resRevenues" sortMode="multiple" [responsive]="true" styleClass="p-datatable-striped">

  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [style.white-space]="'nowrap'"
          [style.font-size]="'80%'">
          {{col.header}}<br>
          <p-sortIcon [field]="col.field" [style.height]="'20%'"></p-sortIcon>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      @for (col of columns; track col) {
        @if (col.field==='year') {
          <td>
            {{ rowData[col.field] }}
          </td>
        }
        @if (col.field==='monthName') {
          <td>
            {{ rowData[col.field] }}
          </td>
        }
        @if (col.field==='day') {
          <td>
            {{ rowData[col.field] | date:'shortDate' }}
          </td>
        }
        @if (col.field==='numNtsUnAvailToRentTTL') {
          <td>
            {{ rowData[col.field] }}<br>
            <span style="color:grey">{{ rowData['pctNtsUnAvailToRent']  | percent}}</span>
          </td>
        }
        @if (col.field==='numNtsAvailToRentTTL') {
          <td>
            {{ rowData[col.field] }}<br>
            <span style="color:grey">{{ rowData['pctNtsAvailToRent']  | percent}}</span>
          </td>
        }
        @if (col.field==='numNtsRentedTTL') {
          <td [style.white-space]="'nowrap'">
            <table>
              <tr>
                <td style="text-align: right;"><span
                style="background-color:hsl({{rowData['pctNtsRented']*100}},100%,50%)">{{ rowData[col.field] }}</span>
              </td>
              <td> / {{ rowData['numNtsAvailToRentTTL']}}</td>
            </tr>
            <tr>
              <td style="text-align: right;color:grey;white-space:nowrap;">
              {{ rowData['pctNtsRented']  | percent}}</td>
              <td style="color:grey;white-space:nowrap;"> / {{ rowData['pctNtsAvailToRent']  | percent}}
              </td>
            </tr>
          </table>
        </td>
      }
      @if (col.field==='numNtsOccTTL') {
        <td>
          {{ rowData[col.field] }}<br>
          <span style="color:grey;white-space:nowrap;">{{ rowData['pctNtsOcc']  | percent}}</span>
        </td>
      }
      @if (col.field==='numResTTL') {
        <td>
          {{ rowData[col.field] }}<br>
          <span style="color:grey">-</span>
        </td>
      }
      @if (col.field==='revRoomRateNetTTL') {
        <td>
          {{ rowData[col.field]   | currency }}<br>
          <span style="color:grey">{{ rowData['revRoomRateNetAVG']  | currency}}</span>
        </td>
      }
      @if (col.field==='revOwnerNetTTL') {
        <td>
          {{ rowData[col.field] | currency }}<br>
          <span style="color:grey">{{ rowData['revOwnerNetAVG']  | currency}}</span>
        </td>
      }
      @if (col.field==='revHousekeepingTTL') {
        <td>
          {{ rowData[col.field] | currency }}<br>
          &nbsp;
        </td>
      }
      @if (col.field==='revResortTTL') {
        <td>
          {{ rowData[col.field] | currency }}<br>
          &nbsp;
        </td>
      }
      @if (col.field==='revDamageWaiverTTL') {
        <td>
          {{ rowData[col.field] | currency }}<br>
          &nbsp;
        </td>
      }
      @if (col.field==='revCommissionTTL') {
        <td>
          {{ rowData[col.field] | currency }}<br>
          <span style="color:grey">{{ rowData['commissionRateAVG']  | percent}}</span>
          &nbsp;
        </td>
      }
      @if (col.field==='revMgrTTL') {
        <td>
          {{ rowData[col.field] | currency }}<br>
          <span style="color:grey">{{ rowData['revMgrAVG']  | percent}}</span>
          &nbsp;
        </td>
      }
    }
  </tr>
</ng-template>
</p-table>